module.exports = __webpack_public_path__ + "static/img/banner-empleos-home-1680x1050.fdb8fef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-empleos-home-1680x1050.jpg
// module id = 2reV
// module chunks = 47